/**
 * © 2026 iTech India Private Limited. All rights reserved.
 * Licensed under the iTech End User License Agreement (EULA).
 * Unauthorized use or distribution is prohibited.
 */

import { apiClient } from './client.js';

export interface TherapyType {
  readonly id: string;
  readonly name: string;
  readonly defaultDurationMins: number;
  readonly color: string | null;
  readonly active: boolean;
  readonly sortOrder: number;
  readonly createdAt: string;
}

export interface CreateTherapyTypePayload {
  readonly name: string;
  readonly defaultDurationMins?: number;
  readonly color?: string;
  readonly sortOrder?: number;
}

export interface UpdateTherapyTypePayload {
  readonly name?: string;
  readonly defaultDurationMins?: number;
  readonly color?: string;
  readonly active?: boolean;
  readonly sortOrder?: number;
}

const BASE = '/therapy-types';

export const therapyTypesApi = {
  async list(activeOnly = false): Promise<readonly TherapyType[]> {
    const { data } = await apiClient.get<readonly TherapyType[]>(BASE, {
      params: activeOnly ? { active: '1' } : {},
    });
    return data;
  },
  async create(payload: CreateTherapyTypePayload): Promise<TherapyType> {
    const { data } = await apiClient.post<TherapyType>(BASE, payload);
    return data;
  },
  async update(id: string, payload: UpdateTherapyTypePayload): Promise<TherapyType> {
    const { data } = await apiClient.patch<TherapyType>(`${BASE}/${id}`, payload);
    return data;
  },
};
